const nl = {
  global: {
    waiter: 'Ober',
    gastrohome: 'Gastrohome',
    admin: 'Beheeromgeving Gastrohome',
    owner: 'Beheer van [x] • Powered by Gastrohome',
    staff: 'Staff van [x] • Powered by Gastrohome',
    welcome: 'Welkom bij [x] • Powered by Gastrohome',
    goodBye: 'Tot ziens bij [x] • Powered by Gastrohome',
    e404: 'Pagina niet gevonden • Gastrohome',
    saved: 'Opgeslagen',
  },
  e404: {
    title: 'Daar gaat iets mis...',
    copy: 'We kunnen de pagina niet vinden. Mogelijk bestaat deze niet (meer).',
    btn: 'Terug naar Gastrohome',
  },
  browserCheck: {
    title: 'Uw browser wordt helaas niet ondersteund',
    copy:
      'Om optimaal gebruik te kunnen maken van Gastrohome, raden wij het gebruik van Google Chrome aan als browser.',
    btn: 'Download Chrome',
  },
  home: {
    select: 'Selecteer het restaurant waar u heeft besteld:',
  },
  accesCode: {
    copy: 'Vul uw toegangscode in',
    btn: 'Ga naar binnen',
  },
  permissions: {
    questionHeader: 'We zijn er bijna...',
    questionCopy:
      'Om Gastrohome te gebruiken, hebben we toegang nodig tot de webcam en microfoon van uw computer...',
    deniedCopy: 'Het lijkt erop dat deze browser geen toegang heeft tot de webcam',
    deniedBtn: 'Terug naar de entree',
  },
  checkIn: {
    welcome: `Welkom bij`,
    busy: `Het is erg druk in de lobby.<br/>Probeer het over een paar minuten nog een keer.`,
    retry: `Opnieuw proberen`,
    save: 'Opslaan',
    placeholder: 'Hoe mogen we u/jullie noemen?',
  },
  fullScreen: {
    enter: 'Pagina fullscreen weergeven',
    leave: 'Fullscreen modus verlaten',
  },
  seating: {
    welcome: 'Welkom [x], <br /> uw ober komt zo bij u.',
  },
  agora: {
    micOff: 'Microfoon staat uit',
    talkingToWaiter: 'In gesprek met ober',
    watchingAVideo: 'Kijkt een video',
  },
  callWaiter: {
    call: 'Ober',
    called: 'Ober is geroepen',
    message: 'Ober is nog even elders bezig. Een moment geduld aub...',
  },
  finished: {
    back: 'Terug naar de lobby',
    title: 'Hartelijk dank dat wij bij u thuis mochten komen!',
    copy: 'Wij hopen u binnenkort weer te zien. U kunt dit scherm nu sluiten.',
    tipCopy: 'Wilt u een fooi geven aan uw ober? Dat kan via onderstaande button.',
    tipBtn: 'Fooi geven aan',
  },
  offline: {
    title: 'Deze pagina is offline',
    copy: 'Controleer uw internetverbinding en refresh de pagina nadien.',
  },
  auth: {
    loggedInAs: 'Ingelogd als',
    logout: 'Uitloggen',
  },
  staff: {
    lobby: 'Lobby',
    sidebar: {
      guest: 'Gast',
      guests: 'Gasten',
      noneSeatingId: 'Geen seating id',
      restaurantSettings: 'Settings',
    },
    guestBox: {
      startUp: 'Bezig met naam invoeren en camera aanzetten.',
      calledWaiter: 'Wil graag 1 op 1',
      attend: 'Ga 1 op 1',
      isAttended: 'Wordt geholpen',
      stopAttend: 'Stop 1 op 1',
      privateOption: '-- Lobby --',
      canSeeItself: 'Kan zichzelf zien',
      stateWelcome: 'Welkom heten',
      stateService: 'In gesprek',
      stateReturning: 'Terugkerende gast',
      stateWatchingVideo: 'Bekijkt een video',
      confirmFinish: 'Weet je zeker dat je deze gast uit verwijderen?',
      confirmRefresh: 'Weet je zeker dat je de gast wilt laten refreshen?',
    },
    messageBox: {
      placeholder: 'Tik een kort bericht aan de gast',
    },
    saveName: {
      placeholder: 'Naam ober',
    },
    rooms: {
      title: 'Kamers beheren',
      up: 'Omhoog',
      down: 'Omlaag',
      edit: 'Aanpassen',
      delete: 'Verwijderen',
      room: 'Kamer',
      roomEdit: 'aanpassen',
      roomCreate: 'aanmaken',
      name: 'Kamer naam',
      size: 'Maximum aantal personen',
      volumneGuests: 'Volume - gasten',
      volumeArtist: 'Volume - artiest',
      private: 'Privé kamer',
      isEndRoom: 'Is de eindkamer',
      save: 'Opslaan',
      confirm:
        'Weet je zeker dat je deze kamer wilt verwijderen? De gasten worden terug in de lobby geplaatst.',
    },
    videos: {
      title: 'Youtube videos beheren',
      idPlaceholder: 'Youtube video ID',
      descriptionPlaceholder: 'Youtube video beschrijving',
      mute: 'Demp mijn geluid',
      unmute: 'Zet mijn geluid aan',
      add: 'voeg toe',
      save: 'Opslaan',
      confirm: 'Weet je zeker dat je deze video wilt verwijderen?',
      noVideo: 'Geen video geselecteerd',
    },
    participate: {
      start: 'Deelnemen',
      stop: 'Stop deelname',
    },
    artistVideo: {
      title: 'YouTube video afspelen',
      stop: 'Stop de video',
      fullscreen: 'Fullscreen',
      artist: 'Artiest',
    },
  },
  owner: {
    manage: 'beheren',
    settings: 'Instellingen',
    codes: 'Toegangscodes',
    waiters: 'Obers',
    waiterPageLink: 'Naar oberpagina',
    adminPageLink: 'Admin',
    profile: {
      title: 'Instellingen',
      name: 'Restaurant naam',
      wallpaper: 'Achtergrond afbeelding',
      logoSmall: 'Logo Klein - Staat rechtsonderin het scherm bij gasten',
      logoBig: 'Logo groot - Staat op de loginpagina en het eindscherm',
      pickImage: 'Kies afbeelding',
      thankyouTitle: 'Titel bedankt pagina',
      thankyouCopy: 'Tekst bedankt pagina',
      thankyouTipCopy: 'Fooi tekst bedankt pagina',
      seatingWelcomeCopy: 'Welkom tekst',
      seatingWelcomeInfo:
        'Let op: Gebruik [x] op de plek waar de naam van de gast moet komen. Gebruik <br /> voor regeleinden.',
      emptyField: 'Als deze tekst niet ingevuld is wordt de standaard tekst getoond:',
      save: 'Opslaan',
    },
    publish: {
      title: 'Restaurants (de)publiceren',
      btnPublish: 'publiceren',
      btnUnpublish: 'depubliceren',
    },
    accessCodes: {
      title: 'Toegangscodes',
      copy: 'Elke toegangscode is geldig van 06:00 \'s ochtends tot 05:59 de dag erna.',
      headingCodes: 'Code',
      headingValid: 'Geldig op',
      delete: 'Verwijderen',
      confirm: 'Wil je deze seating definitief verwijderen?\nDit kan niet worden teruggedraaid!',
      newTitle: 'Nieuwe toegangscode maken',
      create: 'Aanmaken',
    },
    staffList: {
      title: 'Obers',
      forgotPassword: 'Stuur wachtwoord vergeten mail',
      delete: 'Verwijderen',
      confirm: 'Weet je zeker dat je deze ober zijn rechten wilt ontnemen?',
      receivedMail: 'heeft een email gehad',
    },
    newStaff: {
      title: 'Nieuwe ober toevoegen',
      email: 'E-mailadres',
      save: 'Opslaan',
      alertEmail: 'Je moet even een e-mailadres invullen',
      alertError: 'Fout bij het aanmaken van de nieuwe ober',
    },
  },
  admin: {
    title: 'Gastrohome admin',
    menu: {
      admin: 'Restaurants',
      adminUsers: 'Gebruikers',
    },
    restaurants: {
      allTitle: 'Alle restaurants',
      waiterPage: 'Naar pagina voor obers',
      restaurantPage: 'Naar restaurant beheer pagina',
      delete: 'Verwijderen',
      confirm: 'Wil je dit restaurant definitief verwijderen?\nDit kan niet worden teruggedraaid!',
      newTitle: 'Nieuw restaurant aanmaken',
      newName: ' Restaurant naam',
      newEmail: 'E-mailadres eigenaar',
      save: 'Opslaan',
      alertName: 'Je moet even een restaurantnaam invullen',
      alertDuplicate:
        'Restaurant {name} met id {id} bestaat al (of er ging iets mis bij het aanmaken).',
      alertOwner: 'Er ging iets mis bij het aanmaken van de eigenaar.',
    },
    users: {
      title: 'Alle gebruikers',
      admins: 'Admins',
      owners: 'Eigenaren',
      waiters: 'Obers',
      forgotPassword: 'Stuur wachtwoord vergeten mail',
      deleteAdmin: 'Verwijder als admin',
      deleteOwner: 'Verwijder als owner van dit restaurant',
      deleteStaff: 'Verwijderen als staff van dit restaurant',
      userNotFound: 'Gebruiker niet gevonden',
      confirmDeleteAdmin: 'Weet je zeker dat je deze admin zijn rechten wilt ontnemen?',
      confirmDeleteOwner: 'Weet je zeker dat je deze eigenaar zijn rechten wilt ontnemen?',
      confirmDeleteStaff: 'Weet je zeker dat je deze ober zijn rechten wilt ontnemen?',
      receivedMail: 'heeft een email gehad',
    },
  },
}

export default nl
